<template>
    <BaseDialog
        :showDialog="showDialog"
        headline="lang_GENERIC_CAPTION_EXPORT"
        :close="closeDialog"
        persistent
        maxDialogWidth="600"
        :alvqa="alvqa"
    >
        <template v-slot:dialogText>
            <v-container fluid>
                <v-row>
                    <v-col cols="4">
                        <BaseEditPageDropdown 
                                :context="context"
                                field="Type" 
                                :items="typeItems" 
                                :label="$t('lang_PUBLISHING_WORKS_CAPTION_TYPE')"
                                :selection="true"
                                :withMargin="false"
                                hideDetails
                                :clearable="false"
                                :alvqa="alvqa + '-dropdown-type'"
                            />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <BaseEditPageDropdown 
                            :context="context"
                            field="MappingId"
                            :items="exportMappingsList"
                            :label="$t('lang_GENERIC_CAPTION_ABBREVIATION')"
                            :selection="true"
                            :withMargin="false"
                            hideDetails
                            :clearable="false"
                            :alvqa="alvqa + '-dropdown-mapping-abbreviation'"
                            :error-messages="mappingError"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </template>
        <template v-slot:dialogActions>
            <v-container fluid>
                <v-row>
                    <v-col cols="12" class="text-right">
                        <BaseButton 
                            label="lang_BUTTON_START"
                            @click="exportMapping"
                            :disabled="disabled"
                            :alvqa="alvqa+'-button-start'"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'

export default {
    name: "ContractsPublishingExportDialog",
    components: {
        BaseDialog,
        BaseButton,
        BaseEditPageDropdown
    },
    data() {
        return {
            alvqa: 'contracts-publishing-list-dialog-export',
            context: 'ContractsPublishingExport',
            mappingError: 'Test'
        }
    },
    computed: {
        showDialog: {
            get()       { return this.$store.getters.getShowContractsPublishingExportDialog },
            set(show)   { this.$store.commit('setShowContractsPublishingExportDialog', show) }
        },
        isAllSelected: {
            get()       { return this.$store.getters.getLabelReleasesExportAll },
            set(value)  { this.$store.commit('setLabelReleasesExportAll', value) }
        },
        disabled() {
            if(!this.$store.getters.getContractsPublishingExportDetailsMappingId) return true

            if(this.$store.getters.getIsLoading) return true
            
            return false
        },
        typeItems() {
            return [
                {text: this.$t('lang_ACCOUNT_MAPPINGS'), value: 'mappings', alvqa: this.alvqa + '-dropdown-type-mappings'}
            ]
        },
        getType() {
            return this.$store.getters.getContractsPublishingExportDetailsType;
        },
        exportMappingsList() {
            let mappingsList = this.$store.getters.getMappings
            let retArr = []
            mappingsList.forEach((v) => {
                if (v.direction !== 'export') return;
                 
                retArr.push({
                    value: v.alvId,
                    text: v.abbreviation,
                    alvqa: this.alvqa + `-export-mapping-${v.alvId}`
                })
            })
            return retArr
        },
    },
    methods: {
        closeDialog() {
            this.showDialog = false
            this.isAllSelected = false
        },
        doExport(withTracks = false) {
            if(withTracks) this.$store.commit('setLabelReleasesExportWithTracks', true)

            if(this.isAllSelected) this.$store.dispatch('exportAllLabelReleases')
            else this.$store.dispatch('exportSelectedLabelReleases')
            this.closeDialog()
        },
        exportMapping() {
            this.$store.dispatch('exportContractsPublishingMapping')
            this.closeDialog()
        },
        getMappings() {
            this.$store.commit('setSelectedMappingsDomainsFilter', 'contracts_publishing')
            this.$store.dispatch('fetchMappingsByDomain')
        },
    },
    created() {
        this.getMappings();
    }
}
</script>